import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('en-US').format(value);
}

export function formatPercent(value: number, decimals: number = 1): string {
  return `${value.toFixed(decimals)}%`;
}

export function formatDate(date: string): string {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(date: string): string {
  return new Date(date).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getStatusColor(status: string): string {
  switch (status) {
    case 'OK':
      return 'text-green-600 bg-green-100';
    case 'WARNING':
      return 'text-yellow-600 bg-yellow-100';
    case 'CRITICAL':
      return 'text-orange-600 bg-orange-100';
    case 'BREACH':
      return 'text-red-600 bg-red-100';
    default:
      return 'text-gray-600 bg-gray-100';
  }
}

export function getUtilizationColor(utilization: number): string {
  if (utilization >= 100) return 'bg-red-500';
  if (utilization >= 90) return 'bg-orange-500';
  if (utilization >= 70) return 'bg-yellow-500';
  return 'bg-green-500';
}
